import { render } from "./SettingsNav.vue?vue&type=template&id=7885086c"
import script from "./SettingsNav.vue?vue&type=script&lang=js"
export * from "./SettingsNav.vue?vue&type=script&lang=js"

import "./SettingsNav.vue?vue&type=style&index=0&id=7885086c&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.8.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__